import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoBalanzaService {
  constructor() { }

  //tipo de bloqueo
  tipoBloqueoOB() {
    return {
      NINGUNO: 'NA',
      BLOQUEO_POR_PESO: 'BLOQUEO_POR_PESO',
      BLOQUEO_POR_CALIDAD: 'BLOQUEO_POR_CALIDAD',
      }
  }

  catalogoTipo() {
    return [
      {clave:'Principal', valor: 'Principal'},
      {clave:'General', valor: 'General'}
    ]
  }



}
